import { render } from "./SwitchButton.vue?vue&type=template&id=536135e3&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"

import "./SwitchButton.vue?vue&type=style&index=0&id=536135e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536135e3"]])

export default __exports__